import React from 'react';

interface SidebarProps {
  width?: number;
  items: React.ReactNode[];
  first?: React.ReactNode;
  last?: React.ReactNode;
}

export default function Sidebar({ width = 240, items, first, last }: SidebarProps) {
  return (
    <aside
      className='relative flex select-none flex-col border-r border-gray-default bg-white'
      style={{ minWidth: width }}
    >
      {first}
      <nav className='flex w-full flex-grow flex-col overflow-y-auto overflow-x-hidden text-sm'>{items}</nav>
      {last}
    </aside>
  );
}
